// src/components/RouteGuard.js
import { useContext, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

/**
 * RouteGuard component that enforces role-based route access
 * Redirects kiosk users to /kiosk if they try to access non-kiosk routes
 */
const RouteGuard = ({ children }) => {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Only enforce for kiosk users
    if (user && user.role === 'kiosk') {
      const currentPath = location.pathname;

      // Allow kiosk routes and login/check-in routes
      const isKioskRoute = currentPath.startsWith('/kiosk');
      const isLoginRoute = currentPath === '/login';
      const isCheckInRoute = currentPath.startsWith('/checkin');

      // Redirect kiosk users to /kiosk if they try to access non-kiosk routes
      if (!isKioskRoute && !isLoginRoute && !isCheckInRoute) {
        navigate('/kiosk', { replace: true });
      }
    }
  }, [user, location.pathname, navigate]);

  return children;
};

export default RouteGuard;
